import React, { useState } from "react";
import { Tabs as MuiTabs, Tab as MuiTab } from "@mui/material";

import "./styles.css";
import Helpers from "../../commons/helpers";

interface IProps {
    tabIndex?: number;
    defaultValue?: number;
    tabHeaderList?: string[];
    tabContentList: React.ReactNode[];
    tabVariant?: "fullWidth" | "standard" | "scrollable";
    onChangeTab?: (index: number) => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: any;
    value: any;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index } = props;

    return (
        <div
            role="tabpanel"
            id={`full-width-tabpanel-${index}`}
            hidden={value !== index}
            aria-labelledby={`full-width-tab-${index}`}>
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}

const Tabs: React.FC<IProps> = (props: IProps) => {
    const {
        defaultValue,
        tabHeaderList,
        tabContentList
    } = props;
    const [value, setValue] = useState(defaultValue || 0);

    const handleChange = (event: any, newValue: number) => {
        setValue(newValue)
        props.onChangeTab && props.onChangeTab(newValue);
    }

    return (
        <div>
            {!Helpers.isNullOrEmpty(tabHeaderList) &&
                <div style={{ background: "#FFF" }}>
                    <MuiTabs
                        value={value}
                        scrollButtons="auto"
                        selectionFollowsFocus
                        onChange={handleChange}
                        variant={props.tabVariant}
                        TabIndicatorProps={{ children: <span /> }}
                    >
                        {
                            tabHeaderList.map((header, index: number) => (
                                <MuiTab key={index} label={header} disableRipple className={"c-tabs-root"} />
                            ))
                        }
                    </MuiTabs>
                </div>
            }
            {
                tabContentList.map((tabContent, index) => (
                    <TabPanel
                        key={index}
                        value={value}
                        index={index}
                    >
                        {tabContent}
                    </TabPanel>
                ))
            }
        </div>
    );
}

export default Tabs;
